import { HttpParams } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { isArray, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DeviceAgentSerivce, getOS } from 'src/app/services/DeviceAgent.service';
import { LabelService } from 'src/app/services/label.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-print-label-shipment-dialog',
  templateUrl: './print-label-shipment-dialog.component.html',
  styleUrls: ['./print-label-shipment-dialog.component.scss']
})
export class PrintLabelShipmentDialogComponent implements OnInit {
  pdfUrl: any;
  loading: boolean = false;

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig, private sanitizer: DomSanitizer, private messageService: MessageService, private labelService: LabelService, private translateService: TranslateService, private deviceAgentSerivce: DeviceAgentSerivce) { }

  ngOnInit(): void {
    if (!this.config.data) {
      this.ref.close();
    }
    this.printShipment(this.config.data.type,this.config.data?.isPod ?? false);
  }


  async printShipment(type: 'label' | 'shipment' | 'packageList', ispod:boolean = false): Promise<void> {

    if (this.config.data.isLabel) {
      this.pdfUrl = this.config.data.pdfurl;
      return;
    }
    this.loading = true;

    if (!this.config.data.id) {
      this.messageService.add({
        severity: 'info',
        summary: this.translateService.instant('MESSAGES.CHOOSESHIPMENTFORPRINT'),
      });
      this.close();
      return;
    }
    if (this.config.data.id) {
      let queryParams = new HttpParams().append('printType', type);
      queryParams = queryParams.append('shipmentIds', this.config.data.id);

      if (type === 'shipment' && !ispod) {        
        let ids = isArray(this.config.data.id) ? this.config.data.id : [this.config.data.id];
        let mergedBytes = await this.labelService.PrintWayBillsMerged(ids);
        let blob = await this.base64ToBlob(mergedBytes, 'application/pdf');
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
        this.loading = false;
        return;
      }
      if(type === "shipment" && ispod){        
        let ids = isArray(this.config.data.id) ? this.config.data.id : [this.config.data.id];
        let mergedBytes = await this.labelService.PrintWayBillsMerged(ids,true);
        let blob = await this.base64ToBlob(mergedBytes, 'application/pdf');
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
        this.loading = false;
        return;
      }
      if (getOS() === 'iOS') {
        const url = type === "label" ? await this.labelService.getMultipleLabels(this.config.data.id) : `${environment.apiUrl}/shipments/print?${queryParams.toString()}`;
        await this.deviceAgentSerivce.PrintLabelFromIOS(this.config.data.id, type, queryParams);
      }
      else {
        if (type == 'label') {
          let labelFromPrint = await this.labelService.getLabels(this.config.data);
          let pdfblob = await this.base64ToBlob(labelFromPrint as Uint8Array) // from base64 to blob
          this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(pdfblob)); // this.pdfUrl to be shown in html          
          //old code                  
          // this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(await this.labelService.getMultipleLabels([this.config.data.id]));
        }
        else {          
          this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.apiUrl}/shipments/print?${queryParams.toString()}`);
        }          
      }
      this.loading = false;
    }
  }

  close() {
    this.ref.close();
  }
  async base64ToBlob(base64: Uint8Array | Blob, mime = 'application/pdf') {
    if (typeof (base64) == typeof (Blob)) {
      let arg = (await (base64 as Blob).stream().getReader().read()).value;
      return new Blob([arg], { type: mime })
    } else {
      const byteArray = new Uint8Array(base64 as Uint8Array);
      return new Blob([byteArray], { type: mime });
    }
  }
}
